import {
  Checkbox,
  Divider,
  FormControlLabel,
  List,
  ListItem,
} from "@mui/material";
import { useMemo } from "react";

const EMPTY_SELECTED_VALUES = [];

const Selector = ({
  title,
  options,
  onChange,
  optionName = "name",
  optionValue = "value",
  selectedValues,
}) => {
  const resolvedSelectedValues =
    selectedValues === undefined ? EMPTY_SELECTED_VALUES : selectedValues;

  const selectedSet = useMemo(
    () => new Set(resolvedSelectedValues.map((value) => String(value))),
    [resolvedSelectedValues]
  );

  const displayOptions = useMemo(
    () =>
      (options || []).map((option) => ({
        ...option,
        isChecked: selectedSet.has(String(option[optionValue] ?? option.id)),
      })),
    [options, optionValue, selectedSet]
  );

  const checkedCount = displayOptions.filter((option) => option.isChecked).length;
  const isAllChecked =
    displayOptions.length > 0 && checkedCount === displayOptions.length;
  const isAllIndeterminate = checkedCount > 0 && !isAllChecked;

  const emitChange = (nextOptions) => {
    onChange(
      nextOptions
        .filter((item) => item.isChecked)
        .map((item) => item[optionValue] ?? item.id)
    );
  };

  const onClickAllItems = () => {
    const newIsAllChecked = !isAllChecked;
    const nextOptions = displayOptions.map((option) => ({
      ...option,
      isChecked: newIsAllChecked,
    }));
    emitChange(nextOptions);
  };

  const onClickItem = (option) => {
    const optionKey = String(option[optionValue] ?? option.id);
    const nextOptions = displayOptions.map((item) => ({
      ...item,
      isChecked:
        String(item[optionValue] ?? item.id) === optionKey
          ? !item.isChecked
          : item.isChecked,
    }));
    emitChange(nextOptions);
  };

  return (
    <div className="selector-container">
      <ListItem className="selector-item">
        <FormControlLabel
          control={
            <Checkbox
              checked={isAllChecked}
              indeterminate={isAllIndeterminate}
              onChange={onClickAllItems}
            />
          }
          label={title}
        />
      </ListItem>
      <Divider className="divider" />
      <List className="selector-list">
        {displayOptions.map((option) => (
          <ListItem
            className="selector-item"
            key={String(option[optionValue] ?? option.id)}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={Boolean(option.isChecked)}
                  onChange={() => onClickItem(option)}
                />
              }
              label={option[optionName]}
            />
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default Selector;
